import { render, staticRenderFns } from "./LatestRegisteredAccount.vue?vue&type=template&id=163727c0&scoped=true"
import script from "./LatestRegisteredAccount.vue?vue&type=script&lang=js"
export * from "./LatestRegisteredAccount.vue?vue&type=script&lang=js"
import style0 from "./LatestRegisteredAccount.vue?vue&type=style&index=0&id=163727c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163727c0",
  null
  
)

export default component.exports